import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { FullscreenPopup, Portal } from '@gem/ui-kit';
import { platformInfo } from '@gem/utils';

import { CompactCallView } from '../CompactCallView/CompactCallView';
import { FullScreenCallView } from '../FullScreenCallView/FullScreenCallView';
import { MinimizedCallView } from '../MinimizedCallView/MinimizedCallView';
import { MobileCompactCallView } from '../MobileCompactCallView/MobileCompactCallView';
import { useCallViewContainerPresenter } from './CallViewContainer.presenter';

interface ICallViewContainerProps {
  minimisedViewRedirectPath?: string;
}

export const CallViewContainer: FC<ICallViewContainerProps> = observer(
  ({ minimisedViewRedirectPath }) => {
    const presenter = useCallViewContainerPresenter();

    if (platformInfo.isMobile) {
      return <MobileCompactCallView />;
    }

    if (presenter.call.viewState.isMinimized) {
      return (
        <Portal>
          <MinimizedCallView minimisedViewRedirectPath={minimisedViewRedirectPath} />
        </Portal>
      );
    }

    if (presenter.call.viewState.isFullScreen) {
      return (
        <FullscreenPopup>
          <FullScreenCallView />
        </FullscreenPopup>
      );
    }

    if (presenter.call.viewState.isCompact) {
      return <CompactCallView />;
    }

    return null;
  }
);
